import React from "react";
import { Link } from "react-router-dom";
import { SITE } from "../../config/site";

export default function PublicShell({ children }) {
  return (
    <div className="min-h-screen overflow-x-hidden bg-[rgb(var(--bg-app))] text-[rgb(var(--text-main))]">
      {/* Veacon accent */}
      <div
        className="h-1.5 w-full"
        style={{
          background:
            "linear-gradient(90deg, rgb(var(--brand)), rgb(var(--cool)), rgb(var(--event)))",
        }}
      />

      <div className="relative overflow-hidden">
        {/* Ambient product glow */}
        <div
          className="
            pointer-events-none absolute
            -left-48 -top-48
            h-[520px] w-[520px]
            rounded-full blur-3xl
          "
          style={{
            background:
              "radial-gradient(circle, rgb(var(--brand) / 0.13), transparent 68%)",
          }}
        />

        <div
          className="
            pointer-events-none absolute
            -right-52 top-10
            h-[520px] w-[520px]
            rounded-full blur-3xl
          "
          style={{
            background:
              "radial-gradient(circle, rgb(var(--cool) / 0.09), transparent 68%)",
          }}
        />

        <main className="relative w-full px-4 py-5 sm:px-6 sm:py-7 lg:px-10">
          <div className="mx-auto w-full max-w-4xl">
            <header
              className="
                mb-6 flex items-center justify-between
                rounded-[1.75rem]
                border border-[rgb(var(--border))]
                bg-[rgb(var(--surface)/0.78)]
                px-4 py-3
                shadow-sm backdrop-blur-xl
                sm:px-5
              "
            >
              <Link
                to="/"
                className="flex min-w-0 items-center gap-3"
                aria-label="Veacon home"
              >
                <div
                  className="
                    flex h-11 w-11 shrink-0
                    items-center justify-center
                    overflow-hidden rounded-2xl
                    border border-[rgb(var(--border))]
                    bg-[rgb(var(--elevated))]
                  "
                >
                  <img
                    src="/logo.svg"
                    alt=""
                    className="h-7 w-7"
                  />
                </div>

                <div className="min-w-0">
                  <div className="text-sm font-black tracking-tight">
                    Veacon
                  </div>

                  <div className="hidden text-xs font-semibold text-[rgb(var(--text-muted))] sm:block">
                    Find things to do.
                  </div>
                </div>
              </Link>

              <a
                href={SITE.appStoreUrl}
                target="_blank"
                rel="noreferrer"
                className="
                  inline-flex items-center justify-center
                  rounded-2xl
                  bg-[rgb(var(--brand))]
                  px-4 py-2.5
                  text-sm font-black
                  text-white
                  transition
                  hover:opacity-90
                "
              >
                Get Veacon
              </a>
            </header>

            {children}

            <footer
              className="
                mb-8 mt-6
                rounded-[1.75rem]
                border border-[rgb(var(--border))]
                bg-[rgb(var(--surface)/0.65)]
                p-5
                backdrop-blur-xl
                sm:p-6
              "
            >
              <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
                <Link to="/" className="flex items-center gap-3">
                  <div
                    className="
                      flex h-10 w-10
                      items-center justify-center
                      rounded-2xl
                      border border-[rgb(var(--border))]
                      bg-[rgb(var(--elevated))]
                    "
                  >
                    <img
                      src="/logo.svg"
                      alt=""
                      className="h-6 w-6"
                    />
                  </div>

                  <div>
                    <div className="text-sm font-black">
                      Veacon
                    </div>

                    <div className="text-xs text-[rgb(var(--text-muted))]">
                      Find things to do. Make plans. Meet there.
                    </div>
                  </div>
                </Link>

                <nav className="flex flex-wrap gap-x-4 gap-y-2 text-sm font-bold text-[rgb(var(--text-muted))]">
                  <Link
                    to="/contact"
                    className="transition hover:text-[rgb(var(--text-main))]"
                  >
                    Contact
                  </Link>

                  <Link
                    to="/privacy"
                    className="transition hover:text-[rgb(var(--text-main))]"
                  >
                    Privacy
                  </Link>

                  <Link
                    to="/terms"
                    className="transition hover:text-[rgb(var(--text-main))]"
                  >
                    Terms
                  </Link>
                </nav>
              </div>
            </footer>
          </div>
        </main>
      </div>
    </div>
  );
}